export const baseOSSUrl = '//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com'